import { createGlobalStyle } from 'styled-components';

// Thème aligné sur /stats/sap-sinistres : navy #242166, cartes compactes, tables denses.
const StatistiquesProductionStyle = createGlobalStyle`
    .production-page-header {
        background: linear-gradient(120deg, #242166 0%, #3b378f 100%);
        padding: 18px 24px;
        border-radius: 14px;
        margin-bottom: 16px;
        box-shadow: 0 6px 18px rgba(36, 33, 102, 0.22);
    }

    .production-page-header .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 12px;
    }

    .production-page-header h1 {
        color: #fff;
        margin: 0;
        font-size: 22px;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .production-page-header h1 .anticon {
        font-size: 24px;
    }

    .production-page-header p {
        color: rgba(255, 255, 255, 0.85);
        margin: 4px 0 0 0;
        font-size: 13px;
    }

    .production-page-header .ant-btn {
        border-color: rgba(255,255,255,0.55);
        color: #fff;
        background: rgba(255,255,255,0.08);
    }
    .production-page-header .ant-btn:hover {
        border-color: #fff;
        color: #fff;
        background: rgba(255,255,255,0.18);
    }

    .filters-card {
        border-radius: 12px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    }
    .filters-card .ant-card-body { padding: 14px 16px; }

    .filters-card .filter-item {
        width: 100%;
    }

    .filters-card .filter-item label {
        display: block;
        margin-bottom: 6px;
        font-weight: 600;
        color: #4b5563;
        font-size: 12px;
    }

    .filters-card .filter-item label .anticon {
        margin-right: 6px;
        color: #242166;
    }

    /* Cartes KPI compactes */
    .stat-card {
        border-radius: 14px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
        transition: all 0.2s ease;
        border-left: 3px solid transparent;
    }
    .stat-card .ant-card-body { padding: 16px 18px; }

    .stat-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.10);
    }

    .stat-card:nth-child(1) { border-left-color: #1890ff; }
    .stat-card:nth-child(2) { border-left-color: #16a34a; }
    .stat-card:nth-child(3) { border-left-color: #ff4d4f; }
    .stat-card:nth-child(4) { border-left-color: #242166; }

    .stat-card-highlight {
        background: linear-gradient(135deg, #f3f2fb 0%, #f9f9ff 100%);
    }

    .stat-card .ant-statistic-title {
        font-size: 12px;
        color: #6b7280;
        font-weight: 600;
    }

    .stat-card .ant-statistic-content {
        font-size: 20px;
        font-weight: 700;
    }

    /* Tables denses */
    .ant-table-thead > tr > th {
        background: #f5f6fa;
        font-weight: 600;
        color: #242166;
        border-bottom: 2px solid #e6e8f0;
        font-size: 12.5px;
    }

    .ant-table-tbody > tr:hover > td {
        background: #f4f4fb;
    }

    .ant-table-expanded-row > td {
        padding: 0 !important;
    }

    /* Responsive */
    @media (max-width: 768px) {
        .production-page-header h1 { font-size: 18px; }
        .production-page-header .header-content {
            flex-direction: column;
            align-items: flex-start;
        }
        .stat-card .ant-statistic-content { font-size: 18px; }
    }

    /* Print */
    @media print {
        .layout-menu,
        .navbar,
        .filters-card,
        .production-page-header .ant-space,
        .ant-tabs-nav {
            display: none !important;
        }
        .production-page-header {
            background: white;
            color: black;
            border: 1px solid #d9d9d9;
        }
        .production-page-header h1 { color: black; }
        .stat-card { box-shadow: none; border: 1px solid #d9d9d9; }
        .ant-table { font-size: 10px; }
    }
`;

export default StatistiquesProductionStyle;
